import React, {Component} from 'react';
import prognosIcon from "../assets/prognos_logotyp_white.png";
import styled from "styled-components";
import {NavLink as RouterLink} from "react-router-dom";
import {Auth} from "@aws-amplify/auth";
import ActionButton from "./ActionButton";
import {Colors} from "../assets/style/Constants";

const TopBarBackground = styled.div`
  background-color: ${Colors.primaryColor};
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const TopBarLinksContainer = styled.div`
  padding: 1rem 0;
  display: flex;
`;

const TopBarLogo = styled.img`
  height: 2em;
  padding: 0.6rem;
  border-right: 0.1rem solid #b3b3b3;
`;

const Link = styled(RouterLink)`
  font-weight: bold;
  margin-left: 1rem;
  padding: 1.0rem;
  color: ${Colors.backgroundColor};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background-color: #0c4955;
  }
`;

const EmailText = styled.span`
  color: ${Colors.backgroundColor};
  padding: 1.0rem;
`;

class TopBar extends Component {

    constructor(props) {
        super(props);

        this.state = {
            userEmail: null,
            isDeveloper: false
        }

        this.setupUser()
    }
    handleClick() {

        Auth.signOut()
            .then(() => {
                window.location.href = '/';
            })
            .catch(err => console.log(err));
    }

    setupUser() {
        Auth.currentSession().then(session => {
            let tokenPayload = session.getIdToken().payload;

            const groups = tokenPayload['cognito:groups'];

            this.setState({
                userEmail: tokenPayload.email,
                isDeveloper: groups && groups.includes('developer')
            })
        }).catch(error => console.log(error));
    }

    render() {
        return (
            <TopBarBackground>
                <TopBarLinksContainer>
                    <a href='/'>
                        <TopBarLogo src={prognosIcon}/>
                    </a>
                    <Link to="/">Home</Link>
                    <Link to="/excel-upload">File Upload</Link>
                    <Link to="/time-series">Time Series</Link>
                    <Link to="/recipe">Recipe</Link>
                    <Link to="/source">Source</Link>
                    <Link to="/jobs">Jobs</Link>
                    { this.state.isDeveloper &&
                        <Link to="/developer">Developer</Link>
                    }
                    <Link to="/api-users">API Users</Link>
                </TopBarLinksContainer>
                <div>
                    <EmailText>{this.state.userEmail}</EmailText>
                    <ActionButton
                        color="secondary"
                        className="mt-4 mr-4"
                        text="Sign out"
                        onClick={this.handleClick}/>
                </div>
            </TopBarBackground>
        );
    }
}

export default TopBar;
